import { BaseModel } from '../base/base-model'

/**
 * @memberOf loavies.models.wallet
 * @constructor
 */
export class WalletTransferModel extends BaseModel {
  /**
   * @param {string} type
   * @param {loavies.models.base.PriceModel} amount
   * @param {Date} bookingDate
   * @param {string} description
   */
  constructor({
    type,
    amount,
    bookingDate,
    description,
  }) {
    super()

    /** @type {string} */
    this.type = type

    /** @type {loavies.models.base.PriceModel} */
    this.amount = amount

    /** @type {Date} */
    this.bookingDate = bookingDate

    /** @type {string} */
    this.description = description
  }
}

export const WALLET_TRANSFER_TYPES = {
  REVENUE: 'REVENUE',
  RELEASE: 'RELEASE',
  PAYOUT: 'PAYOUT',
  REFUND: 'REFUND',
  PAYMENT: 'PAYMENT',
  RECONCILE: 'RECONCILE',
}
